import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { ApiService } from '../../../utils/services/api.service';
import { Modal, overlayConfigFactory } from 'ngx-modialog';
import { BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { HttpResponse } from '@angular/common/http';
import { saveAs as importedSaveAs } from "file-saver";
import { ModalComponent } from './modal/modal.component';



@Component({
  selector: 'app-hotel-register-requests',
  templateUrl: './hotel-register-requests.component.html',
  styleUrls: ['./hotel-register-requests.component.scss']
})
export class HotelRegisterRequestsComponent implements OnInit {
  showModal = false

  searchParams = new URLSearchParams();
  pageNumber = new FormControl('1');
  statuses = [
    {
      key: 'Active',
      value: 'Active'
    },
    {
      key: 'PendingActivation',
      value: 'Pending Activation'
    },
    {
      key: 'Decline',
      value: 'Decline'
    },
    {
      key: 'Inactive',
      value: 'Inactive'
    },
    {
      key: 'New',
      value: 'New'
    },
    {
      key: null,
      value: 'All'
    }
  ];
  pageUpperLimit = 10;
  pageLowerLimit = 0;
  pageNumbers = [1];

  count;
  loading = true;
  reg = []
  regStatus = false
  registerId;
  offset = 0;
  statusFilter = new FormControl('PendingActivation');
  hotelNameFilter = new FormControl('');



  constructor(private api: ApiService, private notification: NotificationsService,
    @Inject(DOCUMENT) private document: Document,
    public activatedRoute: ActivatedRoute, public router: Router, public modal: Modal) { }

  ngOnInit() {
    let offset = ((+this.pageNumber.value) - 1) * 10;

    this.getRegistrations();

  }
  getRegistrations(offset?) {

    this.searchParams = new URLSearchParams();
    if (this.hotelNameFilter.value) {
      this.searchParams.set('legalName_Like', this.hotelNameFilter.value);
    } else {
      this.searchParams.delete('legalName_Like');
    }
    if (this.statusFilter.value)


      this.searchParams.set('status_In', this.statusFilter.value);
    this.searchParams.set('offset', offset || '0');
    this.searchParams.set('limit', "10");
    this.searchParams.set('sortBy', "id");
    this.searchParams.set('sortType', "desc");
    this.loading = true;
    this.api.getHotelRegistrations(this.searchParams).subscribe(res => {

      this.pageNumbers = [];
      for (let index = 1; index <= Math.ceil(res.data.count / 10); index++) {//kac otel varsa ona gore sayfa sayisini ayarla
        this.pageNumbers.push(index);
      }
      this.regStatus = true
      this.loading = false;
      this.count = res.data.count;

      this.reg = res.data.rows;
    }, err => {
      this.offset = 0;
      this.loading = false;
      this.regStatus = false

    })
  }
  setApprove(registerId,register) {
    this.registerId = registerId;
    let dialogRef = this.modal.open(
      ModalComponent,
      overlayConfigFactory({ size: 'lg', isAgencyView: true, registerId: this.registerId,value:true,register:register }, BSModalContext));
    dialogRef.result.then((response) => {
      if (response.result) {
        this.getRegistrations();
      }
    });
  }
  setDecline(registerId) {
    this.registerId = registerId;
    let dialogRef = this.modal.open(
      ModalComponent,
      overlayConfigFactory({ size: 'lg', isAgencyView: true, registerId: this.registerId,value:false }, BSModalContext));
    dialogRef.result.then((response) => {
      if (response.result) {
        this.getRegistrations();
      }
    });
  }
  download(hotelId, file) {
    this.api.downloadFiles(hotelId, file.name).subscribe(res => {
      let blob = new Blob([res], { type: 'application/pdf' });
      importedSaveAs(blob, file.displayName);
    })
  }

  setPage(pageNumber) {
    if (pageNumber + 2 >= this.pageUpperLimit)
      this.pageUpperLimit = pageNumber + 5;

    this.pageLowerLimit = pageNumber - 5;
    if (this.pageLowerLimit < 0) {
      this.pageLowerLimit = 0;
      this.pageUpperLimit = 10;
    }
    this.offset = ((+pageNumber) - 1) * 10;
    this.getRegistrations(this.offset);
  }

}


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/hotel-register-requests/hotel-register-requests.component.ts